import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcd980b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-test": "uploadFiles" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bx bx-upload mr-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Upload documents", -1))
const _hoisted_4 = ["multiple"]
const _hoisted_5 = { class: "file-name text truncate pl-4 pr-8" }
const _hoisted_6 = ["data"]
const _hoisted_7 = {
  key: 1,
  class: "img-placeholder img-loader"
}
const _hoisted_8 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "red",
  style: {"width":"80","height":"52"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  style: {"fill":"black"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

import { ref, computed } from 'vue';
import useHeicConverter from '@ds/composables/useHeicConverter';

interface ComposedFile extends File {
	name: string;
	url: string;
	isPdf: boolean;
	isHeic: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFiles',
  props: {
    singleFile: { type: Boolean }
  },
  emits: ['addFiles', 'updateFiles'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;


const input = ref<HTMLInputElement | null>(null);
const rawFiles = ref<File[]>([]); // Original files to be send to the server

const { convertedFiles, isConvertingFiles, errorConvertingFiles } = useHeicConverter<File>({
	files: rawFiles,
});
/**
 * PDF and HEIC(to jpeg) for preview
 * If upload images in safari while allwoing heic extension
 * all images get converted to heic but its natively supported
 * https://forums.developer.apple.com/forums/thread/743049
 */
const composedFiles = computed((): ComposedFile[] => {
	return rawFiles.value.map((file: File) => {
		const isPdf = file.type?.includes('pdf');
		const isHeic = file.type?.includes('heic');

		return {
			...file,
			name: file.name,
			url: URL.createObjectURL(file),
			isPdf,
			isHeic,
		};
	});
});

const handleUploadedFiles = async (event: Event) => {
	const { files } = event.target as HTMLInputElement;
	rawFiles.value = [...(files as FileList)];
	emit('addFiles', rawFiles.value);
};

const handleDeleteFile = (event: Event, fileName: string) => {
	event.preventDefault();

	rawFiles.value = rawFiles.value.filter((file: File) => file.name !== fileName);
	emit('updateFiles', rawFiles.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      tabindex: "0",
      class: "upload-document-btn items-center px-2 bg-warning-400 border-radius-2 text-weight-medium cursor-pointer",
      onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => ((input.value as HTMLInputElement)?.click && (input.value as HTMLInputElement)?.click(...args)), ["prevent"]), ["enter"]))
    }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("input", {
        ref_key: "input",
        ref: input,
        type: "file",
        accept: "image/*,.pdf,.heic",
        multiple: !_ctx.singleFile,
        "data-test": "uploadFilesInput",
        onChange: handleUploadedFiles
      }, null, 40, _hoisted_4)
    ], 32),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(composedFiles.value, (file, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `file-${index}`,
        "data-test": "uploadFilesList",
        class: "flex items-center justify-between bg-neutral-100 border-radius-2 p-2 mt-2"
      }, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(file.name), 1),
        (file.isPdf)
          ? (_openBlock(), _createElementBlock("object", {
              key: 0,
              data: file.url,
              type: "application/pdf",
              class: "file-preview"
            }, " uploaded file ", 8, _hoisted_6))
          : (file.isHeic && _unref(isConvertingFiles))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : (file.isHeic && _unref(errorConvertingFiles))
              ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
              : (_openBlock(), _createElementBlock("img", {
                  key: 3,
                  src: 
					file.isHeic ? (_unref(convertedFiles) as ComposedFile[])?.find((f) => f?.name === file.name)?.url : file.url
				,
                  alt: "",
                  class: "file-preview"
                }, null, 8, _hoisted_11)),
        _createElementVNode("button", {
          "aria-label": "Remove uploaded file",
          title: "Remove uploaded file",
          class: "justify-end px-3 mr-2",
          onClick: _withModifiers(($event: any) => (handleDeleteFile($event, file.name)), ["stop"])
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15))
        ], 8, _hoisted_12)
      ]))
    }), 128))
  ]))
}
}

})